import store from '@shared/store/index';

import { computed } from "vue";
import { useUserAuth } from '@/Groups/Audioplayer/private/imports/externalStoreData';

const { hasPaidAccount, isLoadingUserData } = useUserAuth();

//---------------------------------------------------------------------
/**
 * Список коинов из портфеля.
 * @type {import('vue').ComputedRef<Object>}
 */
const assets = computed(() => [...store.state.Briefcase.assets].sort((a, b) => a.index - b.index));
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Используется ли редактирование
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isEditing = computed(() => store.state.Briefcase.isEditing);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Готов ли виджет к показу
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isReady = computed(() => store.state.Briefcase.isReady);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Открыт ли раздел поиска монет
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isCoinSearchOpened = computed(() => store.state.Briefcase.isCoinSearchOpened);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Промежуточный массив для выбранных из поиска монет для дальнейшей их отправки на сервер
 * @type {import('vue').ComputedRef<Array>}
 */
const pendingAssets = computed(() => store.state.Briefcase.pendingAssets);
//---------------------------------------------------------------------

//---------------------------------------------------------------------
/**
 * Открыт ли раздел поиска монет
 * @type {import('vue').ComputedRef<Boolean>}
 */
const isLoadingAssets = computed(() => store.state.Briefcase.isLoadingAssets);
//---------------------------------------------------------------------

/**
 * Composable-функция для работы с коинами из портфеля
 * Предоставляет реактивные свойства состояния портфеля.
 * 
 * @example
 * const { assets } = useBriefcaseState();
 * 
 * @returns {{
 *   assets: import('vue').ComputedRef<Array>, // Список коинов из портфеля
 *   isCoinSearchOpened: import('vue').ComputedRef<Boolean>, // Открыт ли раздел поиска монет
 *   
 * }}
 */


export function useBriefcaseState() {
  return {
    assets,
    isCoinSearchOpened,
    isLoadingAssets,
    isEditing,
    isReady,
    pendingAssets
  };
}